const frontendURL = '/cat/zvt/';
const backendURL = '/api/references/zvt/';
const name = 'Засіб вимірювальної техніки (ЗВТ)';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
